window.SubscriptionFunnel.StepProductLine = {
  handleProductLineSelection(e, bb_vs_sc_redirect, bb_vs_sc_combo_redirect, bb_vs_all_treats_redirect) {
    const selectedOption = document.querySelector(
      `#select-product-line .product-line-radio:checked`
    );

    const validProductLineSelection =
      this.validateProductLineSelection(selectedOption);
    if (validProductLineSelection) {
      this.sendProductLineSelectionEvent(bb_vs_sc_redirect, bb_vs_sc_combo_redirect, bb_vs_all_treats_redirect);
      if (selectedOption?.value === "superchewer") {
        window.location.href = bb_vs_sc_redirect
          ? `/pages/${bb_vs_sc_redirect}`
          : "/pages/superchewer-subscription-funnel-dd-ff";
      } else if (selectedOption?.value === "barkboxcombo") {
        window.location.href = bb_vs_sc_combo_redirect
          ? `/pages/${bb_vs_sc_combo_redirect}`
          : "/pages/combobox-subscription-funnel-tiers-v1";
      } else if (selectedOption?.value === "alltreats") {
        window.location.href = bb_vs_all_treats_redirect
          ? `/pages/${bb_vs_all_treats_redirect}`
          : "/pages/alltreats-subscription-funnel-ff";
      } else {
        SubscriptionFunnel.FunnelNavigation.nextStep();
      }
    }
  },

  validateProductLineSelection(selectedOption) {
    if (!selectedOption) {
      document
        .querySelectorAll("#select-product-line .product-line-card")
        .forEach((el) => {
          el.classList.add("card--error");
        });

      return false;
    }

    return true;
  },

  sendProductLineSelectionEvent(bb_vs_sc_redirect, bb_vs_sc_combo_redirect, bb_vs_all_treats_redirect) {
    const scRedirectPath = bb_vs_sc_redirect
      ? `/pages/${bb_vs_sc_redirect}`
      : "/pages/superchewer-subscription-funnel-dd-ff";
    const comboRedirectPath = bb_vs_sc_combo_redirect
      ? `/pages/${bb_vs_sc_combo_redirect}`
      : "/pages/combobox-subscription-funnel-tiers-v1";
    const allTreatsRedirectPath = bb_vs_all_treats_redirect
      ? `/pages/${bb_vs_all_treats_redirect}`
      : "/pages/alltreats-subscription-funnel";
    const subscriberType = window.subscriberType;
    const selectedOption = document.querySelector(
      `#select-product-line .product-line-radio:checked`
    );

    let params = {
      "Selected Product Line": selectedOption?.value,
      brand: SubscriptionFunnel.FunnelUtilities.subscription_type,
      promo: SubscriptionFunnel.FunnelUtilities.promo_type,
      "Play Subscription Collection Name":
        SubscriptionFunnel.FunnelUtilities.collection_name,
      subscriberType,
      "Super Chewer Funnel Redirect Path": scRedirectPath,
      "Combo Funnel Redirect Path": comboRedirectPath,
      "All Treats Funnel Redirect Path": allTreatsRedirectPath,
    };

    Shopify.analytics.publish("rudderstack_track", {
      eventName: "Product Line Selected",
      eventData: params
    });
  },
};
